import { render, staticRenderFns } from "./banner-edit.vue?vue&type=template&id=31a22f46&scoped=true&"
import script from "./banner-edit.vue?vue&type=script&lang=js&"
export * from "./banner-edit.vue?vue&type=script&lang=js&"
import style0 from "./banner-edit.vue?vue&type=style&index=0&id=31a22f46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a22f46",
  null
  
)

export default component.exports